@if (options().length > 0) {
  <div role="tablist" aria-label="Tabs"
       class="isolate flex w-full divide-x divide-gray-200 overflow-hidden rounded-lg bg-white shadow">
    @for (option of options(); track option.id; let i = $index) {
      <button #tab type="button" role="tab" [id]="tabId(option)"
              [attr.aria-selected]="isActive(option)" [attr.tabindex]="isActive(option) ? 0 : -1"
              (click)="select(option)" (keydown)="onKeydown($event, i)"
              class="group relative min-w-0 flex-1 select-none bg-white px-2 py-4 text-center text-sm
                     font-medium transition-colors duration-200 hover:bg-gray-50 focus:z-10
                     focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset
                     focus-visible:ring-theme-primary-500 sm:px-4"
              [class.text-theme-primary-700]="isActive(option)" [class.text-gray-700]="!isActive(option)">
        <span>{{ option.name }}</span>
        <span aria-hidden="true" class="absolute inset-x-0 bottom-0 h-0.5"
              [class.bg-theme-primary-700]="isActive(option)" [class.bg-transparent]="!isActive(option)"></span>
      </button>
    }
  </div>
}
